import { useState } from 'react';
import Button from '../../../components/ui/Button';

interface TextResponseProps {
  disabled?: boolean;
  submitted?: boolean;
  onSubmit: (payload: { text: string }) => void;
}

// Free-text response — {text} payload. Used for reflections, exit tickets,
// short-answer capture, and group-whiteboard write-ups.
//
// /class live redesign (2026-09-11): 16 px text (`text-base`) for the same
// reason as NumericResponse — anything smaller makes iOS Safari zoom the page
// on focus — and a full-width primary Submit on a phone, because this is the
// one action on screen and a 32 px secondary button was not reading as one.
export default function TextResponse({ disabled, submitted, onSubmit }: TextResponseProps) {
  const [value, setValue] = useState('');

  const submit = () => {
    if (!value.trim()) return;
    onSubmit({ text: value.trim() });
  };

  return (
    <div className="space-y-2">
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
        rows={4}
        placeholder="Type your answer…"
        // WIP-007: a placeholder is not an accessible name (WCAG 3.3.2 / 4.1.2)
        // — this textarea had no label at all otherwise.
        aria-label="Your answer"
        className="w-full resize-none rounded-lg border border-ws-border bg-ws-surface px-3 py-2.5 text-base text-ws-ink placeholder:text-ws-ink-4 focus:border-ws-accent focus:outline-none disabled:cursor-not-allowed disabled:opacity-60"
      />
      <Button
        size="lg"
        className="w-full sm:w-auto"
        disabled={disabled || !value.trim()}
        onClick={submit}
      >
        {submitted ? 'Update answer' : 'Submit'}
      </Button>
    </div>
  );
}
